import React, {useEffect, useState} from 'react';
import api from '../api/axiosInstance';
import {Button} from '../components/Button';
import ProductFormModal from "../components/ProductFormModal";

export default function AdminProductManager() {
    const [products, setProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingProduct, setEditingProduct] = useState(null);

    useEffect(() => {
        fetchProducts(currentPage);
    }, [currentPage]);

    const fetchProducts = async (page = 1) => {
        const res = await api.get(`/admin/products?page=${page}`);
        setProducts(res.data.products);
        setTotalPages(res.data.pageCount);
    };

    const openCreateModal = () => {
        setEditingProduct(null);
        setModalOpen(true);
    };

    const openEditModal = (product) => {
        setEditingProduct(product);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setEditingProduct(null);
    };

    const handleSave = async (productData) => {
        const payload = {
            ...productData,
            daysToHoliday: Number(productData.daysToHoliday),
        };
        if (editingProduct) {
            await api.put(`/admin/products/${editingProduct._id}`, payload);
        } else {
            console.log(payload);
            await api.post('/admin/products', payload);
        }
        closeModal();
        fetchProducts(currentPage);
    };

    const handleDelete = async (id) => {
        await api.delete(`/admin/products/${id}`);
        fetchProducts(currentPage);
    };

    return (
        <div className="p-4 space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold">Product Manager</h1>
                <div className="flex gap-2">
                    <Button onClick={openCreateModal}>Add Product</Button>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full table-auto border-collapse">
                    <thead>
                    <tr className="bg-gray-100 text-left">
                        <th className="px-4 py-2">Title</th>
                        <th className="px-4 py-2">Supplier</th>
                        <th className="px-4 py-2 hidden md:table-cell">SKU</th>
                        <th className="px-4 py-2 hidden md:table-cell">Price</th>
                        <th className="px-4 py-2">Days to Holiday</th>
                        <th className="px-4 py-2">Google Feed</th>
                        <th className="px-4 py-2">Google Product Category</th>
                        <th className="px-4 py-2">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {products.map((product) => (
                        <tr key={product._id} className="border-b even:bg-gray-100">
                            <td className="px-4 py-2 max-w-[20vw] truncate">{product.title}</td>
                            <td className="px-4 py-2 max-w-[20vw] truncate">{product.supplier}</td>
                            <td className="px-4 py-2 max-w-[12vw] truncate hidden md:table-cell">{product.sku}</td>
                            <td className="px-4 py-2 hidden md:table-cell">${product.price.toFixed(2)}</td>
                            <td className="px-4 py-2">{product.daysToHoliday}</td>
                            <td className="px-4 py-2">{product.googleDisplay.toString()}</td>
                            <td className="px-4 py-2">{product.googleProductCategory}</td>
                            <td className="px-4 py-2 space-x-2">
                                <div className="flex gap-2">
                                    <Button onClick={() => openEditModal(product)}>Edit</Button>
                                    <Button onClick={() => handleDelete(product._id)}>Delete</Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-center gap-2 mt-4">
                <Button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>
                    Previous
                </Button>
                <span className="px-4 py-2">Page {currentPage} of {totalPages}</span>
                <Button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                        disabled={currentPage === totalPages}>
                    Next
                </Button>
            </div>

            {modalOpen && (
                <ProductFormModal
                    open={modalOpen}
                    onClose={closeModal}
                    onSubmit={handleSave}
                    product={editingProduct}
                />
            )}
        </div>
    );
}
